export { setupMintbaseWallet } from './setup';
